module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('c-panel-container', [_c('c-panel', {
    attrs: {
      "title": _vm.versionText,
      "img": _vm.versionImg
    }
  })], 1), _vm._v(" "), _c('c-title-line', {
    class: [_vm.noBorder ? 'no-border' : ''],
    attrs: {
      "title": _vm.textTitle
    }
  }), _vm._v(" "), _c('c-button-recharge', {
    attrs: {
      "title": _vm.needMoney,
      "desc": _vm.everyNeedMoney,
      "commend": _vm.btnColor
    }
  }), _vm._v(" "), (_vm.ifShowLeftDate) ? _c('c-title-line', {
    class: [_vm.noBorder ? 'no-border' : ''],
    attrs: {
      "title": ("* " + (this.leftDate) + "天后恢复原价：￥" + (this.relMoney) + "/年（￥￥" + (this.relEveryDayMoney) + "/天）")
    }
  }) : _vm._e(), _vm._v(" "), _c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.buy($event)
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.btnText))])])], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b7bf04","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/renewal/index.vue
// module id = 1009
// module chunks = 2